const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    action_types: {
      type: 'array',
      title: 'نوع گزارش',
      items: {
        type: 'string',
        enum: [
          'SET_IMAGES',
          'CREATE_ALL',
          'CREATE_PRODUCT',
          'UPDATE_PRODUCT',
          'UPDATE_PRODUCTSHOP',
          'UPDATE_ALL',
          'SYNC',
          'LEVEL_2',
          'INTERIOR',
          'ARCHIVE',
        ],
      },
      uniqueItems: true,
    },
  },
});



export default schema;
